<template>
  <div class="offer-wrapper">
    <div class="shadow"></div>
    <div >
      <h5 class="h5-small pointer" @click="showDetails()">
        {{  this.campaign.name  }}
      </h5>
    </div>
    <div>
      <p class="description" v-html="this.campaign.description.substring(0,50)"></p>
    </div>
    <div v-if="this.editable">
      <a @click="editPushDetails()" class="edit">
        <img src="@/assets/images/cms-mkt/edit.svg" />
      </a>
      <a @click="deletePush()" class="delete">
        <img src="@/assets/images/cms-mkt/delete.svg" />
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: "PushCase",
  components: {},

  props: {
    editable: Boolean,
    user: Object,
    campaign: Object,
  },
  data() {
    return {
      // gameData: null,
    };
  },
  methods: {
    showDetails() {
      console.log("showdetails");
      this.$emit("showdetails", this.campaign);
    },
    editPushDetails() {
      this.$emit("edit", this.campaign);
    },
    deletePush() {
      this.$emit("delete", this.campaign);
    },
  }, 
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
